export default __webpack_public_path__ + "assets/time.7d4f4899.svg";